import * as React from 'react';
import AssetListDesktop from './AssetListDesktop';


const AssetListMobile = () => {

    return (<AssetListDesktop/>)
}

export default AssetListMobile;